module.exports = __webpack_public_path__ + "img/Logo.d9235531.svg";